import { gql } from '@apollo/client';

/** Connection Type Table DB - Connection Type */
export const QUERY_GET_CONNECTION_TYPES = gql`
  query AdminQueriesGetConnectorConnectionTypes {
    AdminQueries {
      getConnectorConnectionTypes {
        id
        connectionType
        __typename
      }
    }
  }
`;
